module.exports = __webpack_public_path__ + "img/pay_bank_18.89fd693d.png";